'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = bindDictionary;

var _collectWords = require('./collect-words');

var _collectWords2 = _interopRequireDefault(_collectWords);

var _spannify = require('./spannify');

var _spannify2 = _interopRequireDefault(_spannify);

var _loader = require('./loader');

var _bubble = require('./bubble');

var _bubble2 = _interopRequireDefault(_bubble);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function bindDictionary(node) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var despannify = void 0;
  var unbubble = (0, _bubble2["default"])();
  var unwatch = (0, _loader.watch)(function () {
    despannify = (0, _spannify2["default"])(node);
  });

  if (options.scan) {
    var words = (0, _collectWords2["default"])(node);
    (0, _loader.schedule)({
      words: words
    });
  } else {
    despannify = (0, _spannify2["default"])(node);
  }

  return function () {
    unbubble();
    unwatch();

    if (!options.leaveGarbage && despannify) {
      despannify();
    }
  };
}